import { render, staticRenderFns } from "./VirtualWell.vue?vue&type=template&id=3112933f"
import script from "./VirtualWell.vue?vue&type=script&lang=js"
export * from "./VirtualWell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports